const STANDARD_TIMEOUT = 30 * 60 * 1000; // 30 minutes
const EXTENDED_TIMEOUT = 30 * 24 * 60 * 60 * 1000; // 30 days

let currentUser = null;
let listeners = [];

export const userSession = {
  // Set the current user and notify listeners
  setUser: (user, rememberMe = false) => {
    currentUser = user;
    // Save user and expiration time to localStorage
    const expiresAt = new Date().getTime() + (rememberMe ? EXTENDED_TIMEOUT : STANDARD_TIMEOUT);
    localStorage.setItem('user', JSON.stringify(user));
    localStorage.setItem('sessionExpires', expiresAt.toString());
    localStorage.setItem('sessionType', rememberMe ? 'extended' : 'standard');
    
    // Log session info
    const remainingTime = Math.round((expiresAt - new Date().getTime()) / 1000 / 60);
    console.log(`Session created: ${rememberMe ? 'Extended (30 days)' : 'Standard (30 min)'}`);
    console.log(`Session expires in: ${remainingTime} minutes`);
    
    listeners.forEach(listener => listener(user));
  },

  // Get the current user
  getUser: () => {
    if (!currentUser) {
      // Try to restore from localStorage
      const savedUser = localStorage.getItem('user');
      const expiresAt = parseInt(localStorage.getItem('sessionExpires'));
      const sessionType = localStorage.getItem('sessionType');
      
      if (savedUser && expiresAt > new Date().getTime()) {
        currentUser = JSON.parse(savedUser);
        // Refresh expiration time
        const timeout = sessionType === 'extended' ? EXTENDED_TIMEOUT : STANDARD_TIMEOUT;
        const newExpiresAt = new Date().getTime() + timeout;
        localStorage.setItem('sessionExpires', newExpiresAt.toString());
      }
    }
    return currentUser;
  },

  // Clear the current user (logout)
  clearUser: () => {
    currentUser = null;
    localStorage.removeItem('user');
    localStorage.removeItem('sessionExpires');
    localStorage.removeItem('sessionType');
    listeners.forEach(listener => listener(null));
  },

  // Subscribe to user changes
  subscribe: (listener) => {
    listeners.push(listener);
    return () => {
      listeners = listeners.filter(l => l !== listener);
    };
  },

  // Check if user is logged in
  isLoggedIn: () => {
    return userSession.getUser() !== null;
  },

  // Get user ID
  getUserId: () => {
    const user = userSession.getUser();
    return user ? user.userId : null;
  },

  // Get user types
  getUserTypes: () => userSession.getUser()?.userTypes || [],

  // Check if user has specific type
  hasUserType: (typeId) => {
    return userSession.getUser()?.userTypes?.includes(typeId) || false;
  }
}; 